import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface CabinetsAndCountertopsProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CabinetsAndCountertops: React.FC<CabinetsAndCountertopsProps> = ({
    required = false,
    propertyGuid,
    isReview = false,
}) => {
    const [cabinetsAndCountertops, set_cabinetsAndCountertops] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Cabinets and Countertops']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Cabinets and Countertops': [b.values?.['Interior']?.['Cabinets and Countertops']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Cabinets and Countertops';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(cabinetsAndCountertops)}
                />
            ) : (
                <MoneyBox
                    id={'cabinetsAndCountertops'}
                    allowNegative={false}
                    value={cabinetsAndCountertops}
                    onChange={(value) => set_cabinetsAndCountertops(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
